export const DATADOG_EVENTS = {
	PAGE_VIEW: 'page_view',
	LANDING_PAGE: 'landing_page',
	PAGE_SUBMIT: 'page_submit',
};

export const DATADOG_PAGES = {
	PET_INFO: 'pet-information',
	SELECT_POLICY: 'select-policy',
	CONTACT_INFO: 'contact-information',
	CONGRATS: 'congratulations',
	RETRIEVE: 'retrieve',
	ERROR: 'error',
	PREQUOTE: 'prequote'
};
